import React from "react";

import { NumberLabel, getRange } from "aible";

import { NUMERICLABEL_PARAMS } from "components/Monitoring/MainGraph";

import numeral from "numeral";

import styles from "./style.module.css";

import { AutoSizer } from "react-virtualized";

import { GRAPH_MODES } from "containers/Monitoring/reducer";

import { LineChart, ResponsiveContainer, Line, XAxis, YAxis, Tooltip } from "recharts";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

const DATA_KEY_LABELS = {
  averageImpact: "Average Impact",
  averageProfit: "Average Impact",
  averageRevenue: "Average Revenue",
  averageCost: "Average Cost",
  count: "Count",
  impact: "Impact",
  cost: "Cost"
};

const CustomToolTip = (props) => {
  const { active, payload, netImpactLabel, label, decimalScale, impactLabel } = props;
  if (!active || !payload) {
    return null;
  }
  const payloadWrapper = payload && payload[0];
  const dataKey = payloadWrapper.dataKey;
  const data = payloadWrapper.payload[dataKey];
  const date = payloadWrapper.payload.date;

  const labelKey = dataKey.substring(0, 6) === "total_" ? dataKey.substring(6, dataKey.length) : dataKey;

  const valueLabel = impactLabel !== undefined ? impactLabel : DATA_KEY_LABELS[labelKey];

  return (
    <div className={styles.toolTipWrapper}>
      <div className={styles.toolTipBody}>
        <strong>{"Date: "}</strong>
        {date}
      </div>
      <div className={styles.toolTipBody}>
        <strong>{valueLabel + ": "}</strong>
        {Number(data.toFixed(1)).toLocaleString()}
      </div>
    </div>
  );
};

export default class NextSubgroups extends React.PureComponent {
  render() {
    const { data, isContinuous, handleRetrain, setupLabels, graphMode, targetValue, targetValueOptions } = this.props;
    if (!data) {
      return <div />;
    }
    return (
      <div className={styles.subgroupsWrapper}>
        {/* <div className={styles.subgroupsTitle}>
          {"Subgroup Behavior"}
        </div> */}
        <div className={styles.subgroupsBody}>
          <SubgroupsTable
            data={data}
            isContinuous={isContinuous}
            handleRetrain={handleRetrain}
            setupLabels={setupLabels}
            graphMode={graphMode}
            targetValue={targetValue}
            targetValueOptions={targetValueOptions}
          />
        </div>
      </div>
    );
  }
}

class SubgroupsTable extends React.PureComponent {
  render() {
    const { data, isContinuous, handleRetrain, setupLabels, graphMode, targetValue, targetValueOptions } = this.props;

    let impactLabel = "";

    switch (graphMode) {
      case GRAPH_MODES.CUMULATIVE:
        impactLabel += "Total ";
        break;
      case GRAPH_MODES.DAILY:
        impactLabel += "Average ";
        break;
    }

    let targetLabel = isContinuous ? setupLabels.costLabel : setupLabels.profitLabel;
    const targetOption = targetValueOptions.find((elem) => elem.value === targetValue);
    if (targetOption !== undefined && targetOption.label !== undefined) {
      targetLabel = targetOption.label;
    }

    impactLabel += targetLabel;

    return (
      <div className={styles.subgroupsTable}>
        <table>
          <tbody>
            <tr>
              <th>{"Contributing Factor"}</th>
              {!isContinuous && <th className={styles.subgroupsTableGraphColumn}>{impactLabel}</th>}
              <th className={styles.subgroupsTableGraphColumn}>{setupLabels.notPursuedTransactionLabel + " Count"}</th>
              {/* {getIsMonitoringDemo() ? (
                <th>{"Actions"}</th>
              ) : <React.Fragment/>} */}
            </tr>
            {Object.values(data).map((d, i) =>
              d ? (
                <SubgroupTableItem
                  key={"subgroupTableItem" + i}
                  data={d && d.data}
                  isContinuous={isContinuous}
                  handleRetrain={handleRetrain}
                  isCumulative={graphMode === GRAPH_MODES.CUMULATIVE}
                  targetValue={targetValue}
                  impactLabel={impactLabel}
                />
              ) : undefined
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

class SubgroupTableItem extends React.PureComponent {
  render() {
    const { data, isContinuous, handleRetrain, isCumulative, targetValue, impactLabel } = this.props;
    if (!(data && data.length)) {
      return <React.Fragment />;
    }
    const label = data[0].label;

    // THIS IS A DEMO FEATURE
    let allowRetrain = false;
    // if (getIsMonitoringDemo()) {
    //   const latestCount = data && data[data.length - 1] && data[data.length - 1].count;
    //   if (label === "Type is Upsell" || label === "Overall") {
    //     allowRetrain = true;
    //   }
    // }

    let impactDataKey = isCumulative
      ? targetValue
      : "average" + String(targetValue)[0].toUpperCase() + String(targetValue).substring(1);

    return (
      <tr>
        <td>{label}</td>
        {!isContinuous && (
          <td>
            <SubgroupTableItemGraph
              data={data}
              dataKey={impactDataKey}
              isCumulative={isCumulative}
              impactLabel={impactLabel}
            />
          </td>
        )}
        <td>
          <SubgroupTableItemGraph data={data} dataKey={"count"} isWholeNumber isCumulative={isCumulative} />
        </td>
        {/* {getIsMonitoringDemo() ? (
          <td>
            <a
              className={allowRetrain ? styles.retrainLink : styles.disabledLink}
              onClick={allowRetrain ? () => {
                handleRetrain(label, data && data.reduce((a, b) => a + b.count, 0))
              } : undefined}
            >{allowRetrain ? "Retrain" : "Insufficient Data"}</a>
          </td>
        ) : <React.Fragment />} */}
      </tr>
    );
  }
}

export class SubgroupTableItemGraph extends React.PureComponent {
  render() {
    const { data, dataKey, isWholeNumber, unitType, isSmall, isCumulative, impactLabel } = this.props;

    let retData = data;
    let retDataKey = dataKey;
    if (isCumulative) {
      retDataKey = "total_" + dataKey;

      let total = 0;

      retData = data.map((currData) => {
        total += currData[dataKey];
        return {
          ...currData,
          [retDataKey]: total
        };
      });
    }

    const latestData = retData && retData[retData.length - 1];
    if (!latestData) {
      return <div />;
    }
    const value = latestData[retDataKey];

    const retUnitType = unitType !== undefined ? unitType : "";

    const isNegative = value < 0 ? "-" : "";
    const retValue = Math.abs(value);
    const yDataMin = Math.min.apply(
      Math,
      retData.map((p) => p[retDataKey] || 0)
    );
    const yDataMax = Math.max.apply(
      Math,
      retData.map((p) => p[retDataKey] || 0)
    );

    let yDomain = getRange(yDataMin, yDataMax);

    return (
      <div className={styles.subgroupTableItemGraphWrapper}>
        <div className={styles.subgroupTableItemGraphLabel + " " + (isSmall ? styles.isSmall : "")}>
          {isNegative + retUnitType + numeral(retValue).format("0.[0]a")}
        </div>
        <div className={styles.subgroupTableItemGraph + " " + (isSmall ? styles.isSmall : "")}>
          <AutoSizer>
            {({ width, height }) => (
              <LineChart width={width} height={height} data={retData} margin={{ top: 5, right: 0, left: 5, bottom: 5 }}>
                <Tooltip
                  content={<CustomToolTip impactLabel={impactLabel} />}
                  itemStyle={{ fontSize: "14px" }}
                  contentStyle={{ fontSize: "14px" }}
                  wrapperStyle={{ background: "#FFFFFF" }}
                />
                <XAxis hide dataKey={"date"} />
                <Line dataKey={retDataKey} stroke={"#5BCF74"} strokeWidth={1} dot={false} />
                <YAxis hide domain={yDomain} />
              </LineChart>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }
}
